import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { SurveyStatusEnum, SurveyTriggerTime, SurveyTriggerType } from '@/models'
import { resetQueries } from '@/utils'

import { USE_GET_SURVEYS_QUERY_KEY } from './get-surveys'

interface ResumeSurveyRequest {
  startTriggerDays?: number
  startTriggerTime?: SurveyTriggerTime
  startTriggerType?: SurveyTriggerType
  surveyId: number
}

export const resumeSurvey = async ({ surveyId, ...payload }: ResumeSurveyRequest) => {
  const response = await authAPI.put(`/survey/${surveyId}`, {
    status: SurveyStatusEnum.enum.Ongoing,
    ...payload,
  })
  return response.data
}

export const useResumeSurvey = () => {
  return useMutation({
    mutationFn: resumeSurvey,
    onSuccess: () => {
      resetQueries([USE_GET_SURVEYS_QUERY_KEY])
    },
  })
}
